import type { LiveBreakdown, LiveSheetTalent } from "../../types/generated/live";
import { sumLine } from "./breakdown";
import { interpolate, type Labels } from "./labels";

export const chanceTest = (total: number, labels: Labels) => interpolate(labels.abilities.chance_test, { n: total });

export type TalentTile = { talent: LiveSheetTalent; total: number | null; lines: string[] };

export function talentTiles(talents: LiveSheetTalent[], breakdowns: { talent: string; breakdown: LiveBreakdown }[], labels: Labels): TalentTile[] {
	const byKey = new Map(breakdowns.map((entry) => [entry.talent, entry.breakdown]));
	return talents.map((talent) => {
		const breakdown = byKey.get(talent.key);
		return { talent, total: breakdown?.total ?? null, lines: breakdown ? [sumLine(breakdown, labels), chanceTest(breakdown.total, labels)] : [] };
	});
}
